import { render } from "./ProfileQuestionToolbar.vue?vue&type=template&id=345ff54b&scoped=true"
import script from "./ProfileQuestionToolbar.vue?vue&type=script&lang=js"
export * from "./ProfileQuestionToolbar.vue?vue&type=script&lang=js"

import "./ProfileQuestionToolbar.vue?vue&type=style&index=0&id=345ff54b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345ff54b"]])

export default __exports__